// ============================================================
// VidyaTrack — Landing Footer
// ============================================================
import React from "react";
import { TRUST } from "../data/landingData";

export default function LandingFooter({ scroll }) {
  const cols = [
    { title:"Product", links:[
      { label:"Features",     fn:()=>scroll("features") },
      { label:"How It Works", fn:()=>scroll("how-it-works") },
      { label:"Pricing",      fn:()=>scroll("pricing") },
      { label:"Contact",      fn:()=>scroll("contact") },
    ]},
    { title:"Company", links:[
      { label:"About Us", href:"/legal/about" },
      { label:"Careers",  href:"/legal/careers" },
      { label:"Blog",     href:"/legal/blog" },
    ]},
    { title:"Legal", links:[
      { label:"Privacy Policy",   href:"/legal/privacy-policy" },
      { label:"Terms of Service", href:"/legal/terms-of-service" },
      { label:"Cookie Policy",    href:"/legal/cookie-policy" },
      { label:"Security",         href:"/legal/security" },
    ]},
  ];

  const linkBase = { color:"rgba(255,255,255,.48)", fontSize:"0.83rem",
    textDecoration:"none", transition:"color .15s", display:"block",
    background:"none", border:"none", cursor:"pointer",
    fontFamily:"Inter,sans-serif", textAlign:"left", padding:0, marginBottom:9 };

  return (
    <footer style={{ background:"#111827", color:"#fff",
      padding:"52px max(20px,calc((100vw - 1140px)/2)) 24px" }}>

      <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr 1fr 1fr", gap:40, marginBottom:44 }}>
        {/* Brand col */}
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
            <img src="/vtLight.png" alt="VidyaTrack logo" width={40} height={40} loading="lazy" style={{ width:40, height:40, objectFit:"contain" }}/>
            <div>
              <div style={{ fontFamily:"'Poppins',sans-serif", fontWeight:800, fontSize:"0.97rem" }}>VidyaTrack</div>
              <div style={{ fontSize:"0.6rem", color:"rgba(255,255,255,.35)", marginTop:1 }}>School Management System</div>
            </div>
          </div>
          <p style={{ color:"rgba(255,255,255,.40)", fontSize:"0.83rem", lineHeight:1.75,
            maxWidth:270, margin:"0 0 18px" }}>
            School management system for schools in Nepal — homework, attendance,
            notices, study materials and parent communication in one place.
          </p>
          <div style={{ display:"flex", gap:14 }}>
            {TRUST.map(b=>(
              <span key={b.label} title={b.label} style={{ color:"rgba(255,255,255,.25)" }}>{b.icon}</span>
            ))}
          </div>
        </div>

        {/* Link cols */}
        {cols.map(col=>(
          <div key={col.title}>
            <div style={{ fontSize:"0.68rem", fontWeight:700, color:"rgba(255,255,255,.28)",
              textTransform:"uppercase", letterSpacing:"1px", marginBottom:14 }}>{col.title}</div>
            {col.links.map((l,i)=>(
              l.href ? (
                <a key={i} href={l.href} style={linkBase}
                  onMouseEnter={e=>e.currentTarget.style.color="#fff"}
                  onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,.48)"}>
                  {l.label}
                </a>
              ) : (
                <button key={i} onClick={l.fn} style={linkBase}
                  onMouseEnter={e=>e.currentTarget.style.color="#fff"}
                  onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,.48)"}>
                  {l.label}
                </button>
              )
            ))}
          </div>
        ))}
      </div>

      <div style={{ borderTop:"1px solid rgba(255,255,255,.08)", paddingTop:22,
        display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:12 }}>
        <span style={{ color:"rgba(255,255,255,.26)", fontSize:"0.78rem" }}>
          © {new Date().getFullYear()} VidyaTrack. All rights reserved. Made with ❤️ in Nepal
        </span>
        <div style={{ display:"flex", gap:20 }}>
          {[["Privacy","/legal/privacy-policy"],["Terms","/legal/terms-of-service"],["Contact","/legal/contact-page"]].map(([lbl,href])=>(
            <a key={lbl} href={href} style={{ color:"rgba(255,255,255,.26)", fontSize:"0.78rem", textDecoration:"none" }}
              onMouseEnter={e=>e.currentTarget.style.color="#fff"}
              onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,.26)"}>
              {lbl}
            </a>
          ))}
        </div>
      </div>

      {/* Built by credit */}
      <div style={{ textAlign:"center", marginTop:18, fontSize:"0.78rem", color:"rgba(255,255,255,.30)" }}>
        Built by{" "}
        <a href="https://titaniumcode.netlify.app" target="_blank" rel="noopener noreferrer"
          title="Titanium Code Pvt. Ltd — Software Development Company, Nepal"
          style={{ display:"inline-flex", alignItems:"center", gap:6,
            padding:"5px 12px", borderRadius:8, marginLeft:4,
            background:"rgba(255,255,255,.06)", border:"1px solid rgba(255,255,255,.12)",
            color:"rgba(255,255,255,.75)", fontWeight:600, textDecoration:"none",
            transition:"all .15s" }}
          onMouseEnter={e=>{ e.currentTarget.style.background="rgba(255,255,255,.14)"; e.currentTarget.style.color="#fff"; e.currentTarget.style.borderColor="rgba(255,255,255,.3)"; }}
          onMouseLeave={e=>{ e.currentTarget.style.background="rgba(255,255,255,.06)"; e.currentTarget.style.color="rgba(255,255,255,.75)"; e.currentTarget.style.borderColor="rgba(255,255,255,.12)"; }}>
          Titanium Code Pvt. Ltd <span aria-hidden="true" style={{ fontSize:"0.7rem" }}>↗</span>
        </a>
      </div>
    </footer>
  );
}
